import { inject, Injectable } from "@angular/core";

import { TranslateService } from "@ngx-translate/core";

import { GlobalStorageService } from "./global-storage/global-storage.service";
import { Title } from "@angular/platform-browser";
import { ActivatedRouteSnapshot } from "@angular/router";
import { Subscription } from "rxjs";

interface SetTitleArgs {
  newTitleTag: string;
  description?: string;
}

@Injectable({
  providedIn: "root",
})
export class CustomTitleService {
  public readonly translateService: TranslateService = inject(TranslateService);
  private readonly globalStore: GlobalStorageService = inject(GlobalStorageService);
  private readonly title: Title = inject(Title);
  private titleSubscription!: Subscription;

  resolve(route: ActivatedRouteSnapshot): void {
    const titleTag: string = route.data["title"];
    this.setTitle({ newTitleTag: titleTag, description: "Excuela" });
  }

  setTitle({ newTitleTag = "", description = "" }: SetTitleArgs): void {
    const titleTag: string = newTitleTag;

    const lang: unknown = this.globalStore.getStorage("language");
    const targetLang: string = typeof lang === "string" && lang
      ? lang
      : this.translateService.getDefaultLang();
    if (targetLang && this.translateService.currentLang !== targetLang) {
      this.translateService.use(targetLang);
    }

    if (this.titleSubscription) this.titleSubscription.unsubscribe();
    this.titleSubscription = this.translateService
      .get(titleTag)
      .subscribe((translatedTitle) => {
        this.title.setTitle(
          `${translatedTitle}${description ? " - " : ""}${description}`
        );
      });
  }
}
